import { isLandPropertyType, type PropertyTypeIdentity } from './propertyApplicability';

interface PropertyFeatureInput {
  bathrooms?: unknown;
  state_id?: unknown;
}

const bathroomCount = (value: unknown, optional: boolean): number => {
  const empty = value === null || value === undefined ||
    (typeof value === 'string' && value.trim() === '');
  if (empty) {
    if (optional) return 0;
    throw new Error('Indica il numero di bagni');
  }
  const count = typeof value === 'string' ? Number(value.trim()) : value;
  if (typeof count !== 'number' || !Number.isInteger(count) || count < 0) {
    throw new Error('Il numero di bagni deve essere un intero maggiore o uguale a zero');
  }
  return count;
};

export const validateBathroomCountInput = (value: unknown, optional: boolean): true | string => {
  try {
    bathroomCount(value, optional);
    return true;
  } catch (error) {
    return error instanceof Error ? error.message : 'Indica un numero di bagni valido';
  }
};

/** Payload usato sia per insert sia per update. Non assegna uno stato immobiliare fittizio. */
export const normalizePropertyFeaturePayload = (
  input: PropertyFeatureInput,
  propertyType: PropertyTypeIdentity | null | undefined,
): { bathrooms: number; state_id: string | null } => {
  const land = isLandPropertyType(propertyType);
  const state = typeof input.state_id === 'string' ? input.state_id.trim() : '';
  if (input.state_id != null && typeof input.state_id !== 'string') {
    throw new Error('Seleziona uno stato valido');
  }
  if (!land && !state) {
    throw new Error('Seleziona lo stato dell’immobile');
  }
  return { bathrooms: bathroomCount(input.bathrooms, land), state_id: state || null };
};
